module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/PhotographicBackground-05965b73101e27cda0bd461679d6678a.webp";